module.exports = __webpack_public_path__ + "img/level_four_hover.52e2a0a4.png";